var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionUpdate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1L16 5L12 9L12 6.00012C8.68629 6.00012 6 8.68641 6 12.0001C6 12.7353 6.13221 13.4395 6.37415 14.0904L4.8574 15.6072C4.30899 14.5234 4 13.2978 4 12.0001C4 7.58184 7.58172 4.00012 12 4.00012V1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.0002L12 18.0001C15.3137 18.0001 18 15.3138 18 12.0001C18 11.265 17.8678 10.5607 17.6258 9.90981L19.1426 8.39306C19.691 9.47687 20 10.7024 20 12.0001C20 16.4184 16.4183 20.0001 12 20.0001V23.0002L8 19.0002L12 15.0002Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionUpdate);
export default __webpack_public_path__ + "static/media/ic_action_update.1fe24a4797b6e3cb46f259994434a424.svg";
export { ForwardRef as ReactComponent };